import { render } from '@testing-library/react';
import React from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { clearEdit } from '../../../../features/InfoSlice/infoSlice';
import { addToProductList } from '../../../../features/SalesSlice/SalesSlice';
import { useLocation } from 'react-router-dom';
import { FiPackage, FiX } from 'react-icons/fi';
import './MobileDefaultSales.css';


const UpdateModal = ({ updateProduct, setUpdateProduct }) => {
    const products = useSelector((state) => state.salesInvoice.products);
    const purchaseProducts = useSelector((state) => state.salesInvoice.purchaseProducts);
    const [total, setTotal] = useState(false);
    const [changingRate, setChangingRate] = useState(false);
    const [quantity, setQuantity] = useState();
    const [defaultQuantity, setDefaultQuantity] = useState(1);
    const [salesRate, setSalesRate] = useState();
    const [addError, setAddEroor] = useState();
    const [currentStock, setCurrentStock] = useState();
    const [qytError, setQytError] = useState(false);
    const [costTk, setCostTk] = useState(0);
    const [lot, setLot] = useState()
    const [costHistory, setCostHistory] = useState([
        { lot: lot, quantity: 1, rate: costTk }
    ])
    const [initializationDone, setInitializationDone] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();
    const isMobileCheckout = location.pathname.startsWith('/mobile/');

    console.log(costTk);
    console.log(purchaseProducts);
    console.log(costHistory);

    useEffect(() => {
        const defaultCostTkTimeout = setTimeout(() => {
            if (purchaseProducts.length > 0) {
                setCostTk(purchaseProducts[0]?.rate);
                setLot(purchaseProducts[0]?.lot)
            }
        }, 200);
        return () => clearTimeout(defaultCostTkTimeout);
    }, [purchaseProducts]);

    useEffect(() => {
        // Initialize costHistory only once when costTk has a valid value
        if (costTk !== undefined && costTk !== 0 && lot !== undefined && !initializationDone) {
            setCostHistory([{ lot: lot, quantity: 1, rate: costTk }]);
            setInitializationDone(true);
        }
    }, [costTk, lot, initializationDone]);

    const codeRef = useRef('');
    const nameRef = useRef('');
    const quantityRef = useRef();
    const rateRef = useRef();
    const totalRef = useRef();
    const stockRef = useRef();


    const addProduct = () => {
        const code = codeRef.current.innerText;
        const name = nameRef.current.innerText;
        const quantity = quantityRef.current.value;
        const rate = rateRef.current.value;
        const total = totalRef.current.value;
        const cost = parseFloat(quantityRef.current.value) * parseFloat(costTk)

        // dispatch(addToProductList({ code, name, quantity, rate, total, cost }));
        // setUpdateProduct(null);
        if (!isNaN(costTk)) {
            // const cost = parseFloat(quantityRef.current.value) * parseFloat(costTk);
            dispatch(addToProductList({ code, name, quantity, rate, total, cost: costTk, costHistory }));
            setUpdateProduct(null);
        }
    }

    const handleTotal = (event, productStock) => {
        const sellingQuantity = parseFloat(event?.target?.value);
        const newStock = productStock - sellingQuantity;
        setCurrentStock(newStock);
        setQuantity(sellingQuantity);
        setTotal(true);

        if ((event?.target?.value).slice(0, 1) === '.') {
            setQytError(true);
        } else {
            setQytError(false);
        }

        let remainingQuantity = sellingQuantity;
        let totalCost = 0;
        const newCostHistory = [];

        for (const purchase of purchaseProducts) {
            const { rate, quantity, lot } = purchase;

            if (remainingQuantity > quantity) {
                totalCost += quantity * rate;
                remainingQuantity -= quantity;
                newCostHistory.push({ lot, quantity, rate });
            } else {
                totalCost += remainingQuantity * rate;
                newCostHistory.push({ lot, quantity: remainingQuantity, rate });
                setCostTk(totalCost);
                setCostHistory(newCostHistory);
                return; // No need to continue if all quantity is covered by purchases
            }
        }

        // If sellingQuantity is greater than the total available quantity, set the cost to 0 or handle it accordingly
        setCostTk(0);
        setCostHistory(newCostHistory);
    };




    const handleRate = (event) => {
        const rate = parseFloat(event?.target?.value);
        const quantity = parseFloat(quantityRef.current.value);
        console.log(quantity);
        setDefaultQuantity(quantity)
        setSalesRate(rate);
        setChangingRate(true);

    }

    const closeModal = () => {
        setUpdateProduct(null);
    }

    if (isMobileCheckout) {
        return <div className="mobile-default-modal-wrap"><input type="checkbox" id="update-modal" className="modal-toggle" /><div className="modal mobile-default-modal"><div className="mobile-default-modal__card">{products.map((product) => <React.Fragment key={product._id || product.code}><span ref={codeRef} className="hidden">{product.code}</span><span ref={nameRef} className="hidden">{product.name || product.productName || product.product_name}</span><button type="button" onClick={closeModal} className="mobile-default-modal__close" aria-label="Close product selector"><FiX /></button><div className="mobile-default-modal__title"><span><FiPackage /></span><div><small>Add product</small><h3>{product.name || product.productName || product.product_name}</h3><p>{product.code} · Available stock {product.stock}</p></div></div><div className="mobile-default-modal__fields"><label>Quantity<input ref={quantityRef} onChange={(event) => handleTotal(event, product.stock)} type="number" defaultValue={product.quantity} inputMode="decimal" /></label><label>Sale rate<input ref={rateRef} onChange={handleRate} type="number" defaultValue={product.sell} inputMode="decimal" /></label><label>Total<input ref={totalRef} type="number" value={total === false ? changingRate === false ? product.sell : salesRate : changingRate === true ? quantity * salesRate : quantity * parseFloat(product?.sell).toFixed(2)} readOnly /></label><label>Stock after sale<input ref={stockRef} type="number" value={currentStock !== undefined ? currentStock : product?.stock - 1} readOnly /></label></div>{currentStock < 0 || qytError ? <p className="mobile-default-modal__error">Quantity exceeds available stock. Check the quantity before adding.</p> : null}<button type="button" disabled={currentStock < 0 || qytError} onClick={addProduct} className="mobile-default-modal__add">Add to cart</button></React.Fragment>)}</div></div></div>;
    }
    return (
        <div>
            <input type="checkbox" id="update-modal" class="modal-toggle" />
            <div class="modal">
                <div class="modal-box max-w-none w-full lg:w-11/12 lg:ml-60 relative">
                    <label for="update-modal" onClick={closeModal} class="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
                    <h3 class="text-lg text-center font-bold">Add Product <span className='text-error'>{addError}</span></h3>
                    <table class="table w-1/2 mx-auto text-xs">
                        <thead className='text-center'>
                            <tr>
                                <th className='bg-primary text-white normal-case'>Product Code</th>
                                <th className='bg-primary text-white normal-case'>Product Name</th>
                                <th className='bg-primary text-white normal-case'>Quantity</th>
                                <th className='bg-primary text-white normal-case'>Rate</th>
                                <th className='bg-primary text-white normal-case'>Total</th>
                                <th className='bg-primary text-white normal-case'>Stock</th>
                                <th className='bg-primary text-white normal-case'>Action</th>
                            </tr>
                        </thead>
                        {/* (product.name).replace(/\([^\)]+\)\s*$/, '') */}
                        <tbody className='text-center'>
                            {
                                products.map(product => <tr className='hover'>
                                    <td className='text-xs' ref={codeRef}>{product.code}</td>
                                    <td className='text-xs' ref={nameRef}>{product.name}</td>
                                    <td><input ref={quantityRef} onChange={(event) => handleTotal(event, product.stock)} type="number" defaultValue={product.quantity} placeholder="Type here" className="input text-xs text-center input-bordered w-28 max-w-lg" /></td>
                                    <td><input ref={rateRef} onChange={handleRate} type="number" defaultValue={product.sell} placeholder="Type here" className="input text-xs text-center input-bordered w-28 max-w-lg" /></td>
                                    <td><input ref={totalRef} type="number" value={total === false ? changingRate === false ? product.sell : salesRate : changingRate === true ? quantity * salesRate : quantity * parseFloat(product?.sell).toFixed(2)} placeholder="Type here" className="input text-xs text-center input-bordered w-40 max-w-lg" /></td>
                                    <td><input ref={stockRef} type="number" value={currentStock ? currentStock : product?.stock === quantity ? 0 : product?.stock - 1} placeholder="Type here" className="input text-xs text-center input-bordered w-28 max-w-lg" /></td>
                                    <td> <button disabled={currentStock < 0 || qytError} onClick={addProduct} className={`btn btn-sm`}>Add Product</button> </td>
                                </tr>)
                            }

                        </tbody>
                    </table>

                </div>
            </div >
        </div >

    );
};

export default UpdateModal;

//changingStock!==true ? currentStock : product?.stock-1
